import React, { useState, useEffect, useCallback } from 'react';
import { IoIosEye, IoIosEyeOff } from 'react-icons/io';
import styles from './ObjectExport.module.scss';
import * as s from '../../../ressources/StyleGlobal/StyleGlobal';

const ObjectExport = ({ TitleObj, ImgObj, DescriptionObj, JsonCodeObj }) => {
  // Separate state management with hooks
  const [isJsonVisible, setIsJsonVisible] = useState(false);
  const [isCopied, setIsCopied] = useState(false);

  // Handle copy notification timeout
  useEffect(() => {
    let timeoutId;
    if (isCopied) {
      timeoutId = setTimeout(() => {
        setIsCopied(false);
      }, 3000);
    }
    return () => {
      if (timeoutId) {
        clearTimeout(timeoutId);
      }
    };
  }, [isCopied]);

  // Toggle JSON visibility
  const toggleJsonShow = useCallback(() => {
    setIsJsonVisible((prev) => !prev);
  }, []);

  // Copy to clipboard handler
  const copyToClipboard = useCallback(async (text) => {
    try {
      await navigator.clipboard.writeText(text);
      setIsCopied(true);
    } catch (err) {
      console.error('Failed to copy: ', err);
      setIsCopied(false);
    }
  }, []);

  return (
    <div className={[styles.containerObject, s.card, s.text_center].join(' ')}>
      <div className={[styles.TitleObj, s.card_header].join(' ')}>
        {TitleObj}
      </div>
      <div className={[styles.ImgObj, s.card_text].join(' ')}>{ImgObj}</div>
      <div className={[styles.DescriptionObj, s.card_text].join(' ')}>
        {DescriptionObj}
      </div>

      <div className={[styles.jss, s.text_center].join(' ')}>
        <button
          className={[s.btn, s.btn_primary, styles.BTN].join(' ')}
          onClick={toggleJsonShow}
        >
          Code{' '}
          {isJsonVisible ? <IoIosEyeOff size={15} /> : <IoIosEye size={15} />}
        </button>
      </div>

      {isJsonVisible && (
        <div
          className={[styles.JsonCodeObj, s.card_footer, s.text_muted].join(
            ' '
          )}
        >
          <div className={styles.st}>{JsonCodeObj}</div>
          <button
            className={[styles.nes, s.btn, s.btn_primary, styles.BTN].join(' ')}
            onClick={() => copyToClipboard(JsonCodeObj)}
          >
            Copier code
          </button>
          {isCopied && (
            <div
              className="copy-notification"
              style={{
                position: 'fixed',
                top: '0px',
                left: '25.2%',
                backgroundColor: 'green',
                color: 'white',
                padding: '10px',
                borderRadius: '5px',
                zIndex: 1000,
              }}
            >
              "Copié avec succès !"
            </div>
          )}
        </div>
      )}
    </div>
  );
};

export default ObjectExport;
